import { APP_ID, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RbUiComponentsModule, FormFieldsModule } from '@inst-iot/bosch-angular-ui-components';
import { environment } from 'src/environments/environment';
import { JwtInterceptor } from './_shared/helpers/jwt.interceptor';

import { AppComponent } from './app.component';

import { DashboardModule } from './dashboard/dashboard.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RbUiComponentsModule,
    FormFieldsModule,
    HttpClientModule,
    DashboardModule,
  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: APP_ID, useValue: environment.appId }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

